/**
 * Widget Auth Service
 *
 * Handles authentication API calls for widget customers.
 * Methods: register, login, logout
 */

import { WidgetApiClient } from './WidgetApiClient';
import type { AuthResponse, RegisterFormData, LoginFormData } from '../../types/widget/auth';

export class WidgetAuthService {
  private apiClient: WidgetApiClient;
  private providerSlug: string;

  constructor(providerSlug: string, apiClient: WidgetApiClient) {
    this.providerSlug = providerSlug;
    this.apiClient = apiClient;
  }

  /**
   * Register a new customer
   */
  async register(data: Omit<RegisterFormData, 'confirmPassword'>): Promise<AuthResponse> {
    return this.apiClient.post<AuthResponse>(
      `/api/v1/widget/${this.providerSlug}/auth/register`,
      data
    );
  }

  /**
   * Login customer
   */
  async login(data: LoginFormData): Promise<AuthResponse> {
    return this.apiClient.post<AuthResponse>(
      `/api/v1/widget/${this.providerSlug}/auth/login`,
      data
    );
  }

  /**
   * Logout (client-side only - just remove token)
   */
  logout(): void {
    // JWT tokens are stateless, so logout is just removing the token from storage
    // This is handled by WidgetAuthContext
  }
}
